import TYPES from './types'

export const fetchStoreLocatorSuccess = (storeLocator) => ({
  type: TYPES.FETCH_STORE_LOCATOR_SUCCESS,
  payload: storeLocator,
})

export const updateStoreLocatorSuccess = (storeLocator) => ({
  type: TYPES.UPDATE_STORE_LOCATOR_SUCCESS,
  payload: storeLocator,
})



// WEBPACK FOOTER //
// ./src/store/storeLocator/actions.js